// extracted by mini-css-extract-plugin
export var createdDate = "_lu-1";
export var divider = "_lu-2";
export var headerDivider = "_lu-3";
export var messagesCard = "_lu-0";
export var messagesContainer = "_lu-7";
export var messagesContainerWrapper = "_lu-4";
export var pointerCapturingButtonBoxes = "_lu-a";
export var showLeftPanelButton = "_lu-9";
export var showMoreButton = "_lu-c";
export var showMoreButtonContainer = "_lu-b";
export var summaryTitle = "_lu-6";
export var systemMessageCardWrapper = "_lu-d";
export var topButtons = "_lu-8";
export var withPadding = "_lu-5";